// import CookieService from './CookieService'

export default {   

    login: function(data) {
        return window.axios.post(`login`, data);
    },

    logout: function(){
        return window.axios.get(`logout`);
    },

    register: function (data) {
        return window.axios.post(`register`, data);
    },

    passwordEmail: function(data) {
        return window.axios.post(`password/email`, data);
    },

    passwordReset: function(data) {
        return window.axios.post(`password/reset`, data);
    },

    session: function () {
        return window.axios.get(`session`);
    }
}